import {AppMessage} from './app-message';
import { Localization } from "../enums/localization";
import {DateService} from '../services/date.service';

export class AttentionPointMessage extends AppMessage {
  public buildingStructureId: number;
  public buildingStructureLabel: string;
  public inspectionExecutedOn: string;
  public inspectionId: number;
  public inspectionType: string;
  public numberOfAttentionPoints: number;
  public dateService: DateService;
  public checklistLabel: string;

  public getMessage(): string {
    const params = {
      count: this.numberOfAttentionPoints,
      type: this.translateService.instant(this.inspectionType),
      building: this.buildingStructureLabel,
      date: this.dateService.formatToDateFormat(this.inspectionExecutedOn),
      checklist: this.checklistLabel
    };
    let singleMessage: string;
    let pluralMessage: string ;
    if (this.inspectionType.toLowerCase() === 'checklist') {
      singleMessage = this.translateService.instant(Localization.YouHaveUnhandledChecklistAttentionPoint, params);
      pluralMessage = this.translateService.instant(Localization.YouHaveUnhandledChecklistAttentionPoints, params);
    } else {
      singleMessage = this.translateService.instant(Localization.YouHaveUnhandledAttentionPoint, params);
      pluralMessage = this.translateService.instant(Localization.YouHaveUnhandledAttentionPoints, params);
    }
    return this.numberOfAttentionPoints === 1 ? singleMessage : pluralMessage;
  }

  public getRedirectUrl(): string {
    return `buildings/${this.buildingStructureId}/inspections/${this.inspectionId}/checkpoints?pageNumber=1&value=Negative&withIssues=false&withoutConsequences=false`;
  }
}
